import QueriesCard from "./CardList/QueriesCard";
import { Box, Stack } from "@mui/material";
import { queries } from "../../constants/talent-profile";

export default function Queries() {
  return (
    <Box sx={{ overflowY: "auto", maxWidth: "700px" }}>
      <Stack direction="column" gap={2}>
        {queries.map((query, index) => (
          <QueriesCard
            key={index}
            username={query.username}
            email={query.email}
            content={query.content}
            timestamp={query.timestamp}
            likes={query.likes}
            replies={query.replies}
            onLike={() => {}}
            onReply={() => {}}
            onMore={() => {}}
          />
        ))}
      </Stack>
    </Box>
  );
}
